import { Box } from "@mui/material";

const JoinGroupButton: React.FC = () => {
  return (
    <Box
      component="img"
      src="/imgs/gif_code.gif" // make sure this file is placed in /public/imgs/
      alt="Join Group"
      draggable="false"
      sx={{
        position: "fixed", // ✅ stays visible while scrolling
        width: { xs: 100, md: "200px" },
        height: "200px",
        bottom: { xs: 20, md: "371px" },
        right: 10,
        opacity: 1,
        transform: "rotate(0deg)",
        objectFit: "contain",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
        //display: { xs: "none", md: "block" }, // ✅ hide on mobile
        zIndex: 9999, // ✅ ensures it's always on top
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
      onClick={() => {
        window.open("https://t.me/addlist/99uO9eak4w03OGZl", "_blank", "noopener,noreferrer");
      }}
    />
  );
};

export default JoinGroupButton;
